'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');
const { Translate } = require('@grpn/preact-l10n');

const redemptionHandler = require('../../../support/redemption-handler');
const { publish } = require('../../../support/event-observer');

const carriageReturnCode = 13;

function OfferViewTerms({ routes, offerId, className }) {
  const clickRedemptionHandler = () => {
    redemptionHandler({
      routes,
      offerId,
      openOutlink: false,
      action: 'terms',
    }).then(data => publish('@redemption', { ...data, type: 'TERMS' }));
  };

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === carriageReturnCode) {
      clickRedemptionHandler();
    }
  };

  return h(
    `a.${className}`,
    {
      tabindex: 0,
      onClick: clickRedemptionHandler,
      onKeyUp: keyUpRedemptionHandler,
    },
    h(Translate, 'js.modules.shared.ViewTerms')
  );
}

module.exports = hydrate('OfferViewTerms', OfferViewTerms);
